import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-seo-registry-form',
  templateUrl: './seo-registry-form.component.html',
  styleUrls: ['./seo-registry-form.component.css'],
})
export class SeoRegistryFormComponent {
  url: string = 'seoRegistries';
  id!: string;
  form!: FormGroup;
  versions: Array<any> = [];

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/marketing',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/marketing/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/marketing/social/strategy',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'GEO',
      route: '',
    },
    
  ];

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.id = params['id'];

      if (this.id) {
        this.getData();
        this.getVersions();
      }
    });

    this.form = this.fb.group({
      urlPath: ['', [Validators.required]],
      type: ['', [Validators.required]],
      city: ['', [Validators.required]],
      service: ['', [Validators.required]],
      industry: ['', [Validators.required]],
      keyword: ['', [Validators.required]],
    });
  }

  isFieldInvalid(field: string) {
    return (
      this.form.get(field)?.invalid &&
      (this.form.get(field)?.dirty || this.form.get(field)?.touched)
    );
  }

  onSubmit(): void {
    if (this.id) {
      this.updateData();
    } else {
      this.createData();
    }
  }

  getData(): void {
    this.dataService.getData(`${this.url}/${this.id}`).subscribe((response) => {
      this.form.patchValue({
        urlPath: response.urlPath,
        type: response.type,
        city: response.city,
        service: response.service,
        industry: response.industry,
        keyword: response.keyword,
      });
    });
  }

  createData(): void {
    this.dataService
      .postData(`${this.url}/add`, this.form.value)
      .subscribe((response) => {
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
          this.form.reset();
          this.router.navigateByUrl('marketing/seo/registry');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  updateData(): void {
    //console.log('this.form.value',this.form.value);
    this.dataService
      .putData(`${this.url}/edit/${this.id}`, this.form.value)
      .subscribe((response) => {
        //console.log('response', response);
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
          this.form.reset();
          this.router.navigateByUrl('marketing/seo/registry');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  getVersions(): void {
    this.dataService
      .getData(`${this.url}/versions/${this.id}`)
      .subscribe((response) => {
        this.versions = response.data;
      });
  }

  rollback(versionId: string): void {
    if (
      !confirm(
        '¿Desea realizar el rollback a esta versión? Se creará un nuevo registro de versión para trazabilidad.',
      )
    ) {
      return;
    }

    this.dataService
      .postData(`${this.url}/rollback/${this.id}/${versionId}`, {})
      .subscribe((response) => {
        if (response.rst) {
          this.getData();
          this.getVersions();
          this.router.navigateByUrl('marketing/seo/registry');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }
}
